import React from 'react';

const ScenesContext = React.createContext({});

export default ScenesContext;